export default {
  computed: {
    isSunday() {
      var date = new Date(this.date)
      if (date.getDay() == 0) {
        return true
      } else {
        return false
      }
    },
    spoilType() {
      if (!!this.spoilObj) {
        return this.spoilObj.type
      }
      return null
    },
    showHours() {
      if (!this.displayRate) return true;

      if (
        !this.hasRate ||
        this.displayRate.costUnit == "HOUR" ||
        this.displayRate.sellUnit == "HOUR" ||
        this.useAltRate ||
        (this.useNightRate && this.displayRate.costUnitNight == "HOUR") ||
        (this.useNightRate && this.displayRate.sellUnitNight == "HOUR") ||
        (this.isSunday && this.displayRate.costUnitSunday == "HOUR") ||
        (this.isSunday && this.displayRate.sellUnitSunday == "HOUR") //||
        //this.spoilType != "TOL"
      ) {
        return true
      } else {
        return false
      }
    },
    showQty() {
      if (!this.displayRate) return false;
      //console.log(this.displayRate);

      if (
        this.useOverrideCost ||
        this.displayRate.costUnit == "EA" ||
        this.displayRate.sellUnit == "EA" ||
        (this.useNightRate && this.displayRate.costUnitNight == "EA") ||
        (this.useNightRate && this.displayRate.sellUnitNight == "EA") ||
        (this.isSunday && this.displayRate.costUnitSunday == "EA") ||
        (this.isSunday && this.displayRate.sellUnitSunday == "EA") ||
        this.displayRate.costUnit == "DAY" ||
        this.displayRate.sellUnit == "DAY" ||
        (this.useNightRate && this.displayRate.costUnitNight == "DAY") ||
        (this.useNightRate && this.displayRate.sellUnitNight == "DAY") ||
        (this.isSunday && this.displayRate.costUnitSunday == "DAY") ||
        (this.isSunday && this.displayRate.sellUnitSunday == "DAY") ||
        this.spoilType == "TOL"
      ) {
        return true
      } else {
        return false
      }
    },
    showWeight() {
      if (!this.displayRate) { return true };
      if (this.spoilType == "TOL") {
        return false
      } else {
        return true
      }
    },
  }
}